var map = {
	"./cover1/details1.json": "e148",
	"./cover1/details10.json": "3298",
	"./cover1/details11.json": "432e",
	"./cover1/details12.json": "2aa1",
	"./cover1/details13.json": "9dce",
	"./cover1/details14.json": "4547",
	"./cover1/details15.json": "e99e",
	"./cover1/details16.json": "2646",
	"./cover1/details17.json": "d356",
	"./cover1/details18.json": "7b41",
	"./cover1/details19.json": "3580",
	"./cover1/details2.json": "3bd6",
	"./cover1/details20.json": "a762",
	"./cover1/details21.json": "1109",
	"./cover1/details3.json": "c17c",
	"./cover1/details4.json": "c6fc",
	"./cover1/details5.json": "3e39",
	"./cover1/details6.json": "39fb",
	"./cover1/details7.json": "37e7",
	"./cover1/details8.json": "6a63",
	"./cover1/details9.json": "f338",
	"./cover10/details1.json": "459e",
	"./cover10/details10.json": "304a",
	"./cover10/details11.json": "1cec",
	"./cover10/details12.json": "cde2",
	"./cover10/details13.json": "cac9",
	"./cover10/details14.json": "2080",
	"./cover10/details15.json": "1ffc",
	"./cover10/details16.json": "8d06",
	"./cover10/details17.json": "66b0",
	"./cover10/details18.json": "8ec8",
	"./cover10/details19.json": "6a4a",
	"./cover10/details2.json": "f050",
	"./cover10/details20.json": "eac4",
	"./cover10/details21.json": "5f10",
	"./cover10/details3.json": "0887",
	"./cover10/details4.json": "765d",
	"./cover10/details5.json": "c815",
	"./cover10/details6.json": "0370",
	"./cover10/details7.json": "9b64",
	"./cover10/details8.json": "ac7e",
	"./cover10/details9.json": "5f55",
	"./cover2/details1.json": "9d3a",
	"./cover2/details10.json": "d995",
	"./cover2/details11.json": "789b",
	"./cover2/details12.json": "9fad",
	"./cover2/details13.json": "72e3",
	"./cover2/details14.json": "7f23",
	"./cover2/details15.json": "2d10",
	"./cover2/details16.json": "3537",
	"./cover2/details17.json": "9957",
	"./cover2/details18.json": "e267e",
	"./cover2/details19.json": "835b",
	"./cover2/details2.json": "c0e0",
	"./cover2/details20.json": "3061",
	"./cover2/details21.json": "a05c",
	"./cover2/details3.json": "137e",
	"./cover2/details4.json": "ba2a",
	"./cover2/details5.json": "351f",
	"./cover2/details6.json": "959a",
	"./cover2/details7.json": "b2ac",
	"./cover2/details8.json": "31c4",
	"./cover2/details9.json": "1777",
	"./cover3/details1.json": "e04c",
	"./cover3/details10.json": "9efa",
	"./cover3/details11.json": "11f4",
	"./cover3/details12.json": "6467",
	"./cover3/details13.json": "8cd3",
	"./cover3/details14.json": "1f4b",
	"./cover3/details15.json": "2068",
	"./cover3/details16.json": "3bb8",
	"./cover3/details17.json": "4e9f",
	"./cover3/details18.json": "394c",
	"./cover3/details19.json": "2141",
	"./cover3/details2.json": "b35c",
	"./cover3/details20.json": "b33b",
	"./cover3/details21.json": "bd1b",
	"./cover3/details3.json": "d1e1",
	"./cover3/details4.json": "b42e4",
	"./cover3/details5.json": "c1b9",
	"./cover3/details6.json": "0ce3",
	"./cover3/details7.json": "dff1",
	"./cover3/details8.json": "3d14",
	"./cover3/details9.json": "f4c7",
	"./cover4/details1.json": "95c2",
	"./cover4/details10.json": "c290",
	"./cover4/details11.json": "d4fc",
	"./cover4/details12.json": "36e3",
	"./cover4/details13.json": "5804",
	"./cover4/details14.json": "8f68",
	"./cover4/details15.json": "055c",
	"./cover4/details16.json": "b5e4",
	"./cover4/details17.json": "ab82",
	"./cover4/details18.json": "c7fc",
	"./cover4/details19.json": "5f2b",
	"./cover4/details2.json": "ccb2",
	"./cover4/details20.json": "eef2",
	"./cover4/details21.json": "3d4b",
	"./cover4/details3.json": "7e43",
	"./cover4/details4.json": "8ead",
	"./cover4/details5.json": "da98",
	"./cover4/details6.json": "03ea",
	"./cover4/details7.json": "54da",
	"./cover4/details8.json": "0bd5",
	"./cover4/details9.json": "fdd6",
	"./cover5/details1.json": "ba8e",
	"./cover5/details10.json": "f4eb",
	"./cover5/details11.json": "b968",
	"./cover5/details12.json": "8df5",
	"./cover5/details13.json": "0f19",
	"./cover5/details14.json": "90c2",
	"./cover5/details15.json": "2431",
	"./cover5/details16.json": "a81c",
	"./cover5/details17.json": "08d0",
	"./cover5/details18.json": "18d3",
	"./cover5/details19.json": "2b5a",
	"./cover5/details2.json": "1808",
	"./cover5/details20.json": "3f1b",
	"./cover5/details21.json": "3e30",
	"./cover5/details3.json": "775b",
	"./cover5/details4.json": "df86",
	"./cover5/details5.json": "32ca",
	"./cover5/details6.json": "101e",
	"./cover5/details7.json": "d775",
	"./cover5/details8.json": "7c37",
	"./cover5/details9.json": "b7c5",
	"./cover6/details1.json": "3e60",
	"./cover6/details10.json": "97cd",
	"./cover6/details11.json": "0a78",
	"./cover6/details12.json": "365e",
	"./cover6/details13.json": "d216",
	"./cover6/details14.json": "b5b2",
	"./cover6/details15.json": "6182",
	"./cover6/details16.json": "ee39",
	"./cover6/details17.json": "c766",
	"./cover6/details18.json": "cfac",
	"./cover6/details19.json": "8d9f",
	"./cover6/details2.json": "b068",
	"./cover6/details20.json": "e931",
	"./cover6/details21.json": "93f7",
	"./cover6/details3.json": "1e93",
	"./cover6/details4.json": "aa87",
	"./cover6/details5.json": "964a",
	"./cover6/details6.json": "5b8f",
	"./cover6/details7.json": "e7a3",
	"./cover6/details8.json": "b7da",
	"./cover6/details9.json": "4e7d0",
	"./cover7/details1.json": "e77d",
	"./cover7/details10.json": "1ada",
	"./cover7/details11.json": "5259",
	"./cover7/details12.json": "1412",
	"./cover7/details13.json": "e71d",
	"./cover7/details14.json": "6db6",
	"./cover7/details15.json": "3cca",
	"./cover7/details16.json": "14a1",
	"./cover7/details17.json": "99d5",
	"./cover7/details18.json": "4f40",
	"./cover7/details19.json": "5f7f",
	"./cover7/details2.json": "d384",
	"./cover7/details20.json": "c7da",
	"./cover7/details21.json": "0ebe",
	"./cover7/details3.json": "a127",
	"./cover7/details4.json": "9daa",
	"./cover7/details5.json": "898d",
	"./cover7/details6.json": "75a0",
	"./cover7/details7.json": "1081",
	"./cover7/details8.json": "90a3",
	"./cover7/details9.json": "71bd",
	"./cover8/details1.json": "bc36",
	"./cover8/details10.json": "e2dd",
	"./cover8/details11.json": "1288",
	"./cover8/details12.json": "5ed9",
	"./cover8/details13.json": "7ff1",
	"./cover8/details14.json": "2fa1",
	"./cover8/details15.json": "4c7e",
	"./cover8/details16.json": "ea63",
	"./cover8/details17.json": "ba77",
	"./cover8/details18.json": "bcf0",
	"./cover8/details19.json": "14fb",
	"./cover8/details2.json": "bcad",
	"./cover8/details20.json": "72e9",
	"./cover8/details21.json": "8b77",
	"./cover8/details3.json": "cd1d",
	"./cover8/details4.json": "bc1c",
	"./cover8/details5.json": "69a6",
	"./cover8/details6.json": "a93c",
	"./cover8/details7.json": "318a",
	"./cover8/details8.json": "fe8b",
	"./cover8/details9.json": "c105",
	"./cover9/details1.json": "b4a1",
	"./cover9/details10.json": "ef212",
	"./cover9/details11.json": "a9ad",
	"./cover9/details12.json": "0d96",
	"./cover9/details13.json": "a7e5",
	"./cover9/details14.json": "9fbb5",
	"./cover9/details15.json": "52f9",
	"./cover9/details16.json": "fddf",
	"./cover9/details17.json": "332c",
	"./cover9/details18.json": "d973",
	"./cover9/details19.json": "3b7a",
	"./cover9/details2.json": "6363",
	"./cover9/details20.json": "e08b",
	"./cover9/details21.json": "6f0c",
	"./cover9/details3.json": "1af2",
	"./cover9/details4.json": "21b8",
	"./cover9/details5.json": "9c1d",
	"./cover9/details6.json": "0987",
	"./cover9/details7.json": "984a",
	"./cover9/details8.json": "ff83",
	"./cover9/details9.json": "f7ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8bb4";